import DocumentFilledIcon from '@atlaskit/icon/glyph/document-filled';
import VidRaisedHandIcon from '@atlaskit/icon/glyph/vid-raised-hand';
import VideoCircleIcon from '@atlaskit/icon/glyph/video-circle';

import { OnboardingPanelProps } from '../OnboardingPanel/OboardingPanel';

export const onboardingPanelsData: Array<OnboardingPanelProps> = [
  {
    title: 'Onboarding playlist',
    description: 'Check our onboarding playlist on YouTube',
    appearance: 'purple',
    icon: VideoCircleIcon,
    iconLabel: 'onboarding-playlist-icon',
    redirectUrl:
      'https://www.youtube.com/playlist?list=PLmsCeqb4xmdBgN-YuUyuTJG01oIO0suCj',
  },
  {
    title: 'Training session',
    description: 'Schedule a training session with our QAlity expert',
    appearance: 'gray',
    icon: VidRaisedHandIcon,
    iconLabel: 'training-session-icon',
    redirectUrl: 'https://calendly.com/customer-care-xfk/qality-plus-demo',
  },
  {
    title: 'Documentation',
    description: 'Learn more in our documentation',
    appearance: 'gray',
    icon: DocumentFilledIcon,
    iconLabel: 'documentation-icon',
    redirectUrl: 'https://soldevelo.atlassian.net/wiki/spaces/QS/overview',
  },
];
